let unique = 1;

export function getUnique() {
  return unique++;
}
